import { render, staticRenderFns } from "./EditChatModal.html?vue&type=template&id=217975d2&scoped=true&"
import script from "./EditChatModal.vue?vue&type=script&lang=js&"
export * from "./EditChatModal.vue?vue&type=script&lang=js&"
import style0 from "./EditChatModal.scss?vue&type=style&index=0&id=217975d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217975d2",
  null
  
)

export default component.exports